<template>
  <div class="q4" :class="{ fade: fade }">
    <div class="content">
      <AppBar></AppBar>
      <img
        class="q-index"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q4-head"
      />
      <div class="q-title animate__animated animate__fadeInDown">你的体重</div>
      <div class="q-box">
        <div class="weight-content">
          <div class="weight-jin">={{ rulerNum * 2 }}斤</div>
          <div class="weight-kg">
            <div
              ><span class="number">{{ rulerNum }}</span
              ><span class="unit">KG</span></div
            >
          </div>
          <div class="my-rule">
            <CsRuler
              class="cs-rules"
              @change="bindRulerNum"
              :NowNum="defaultNum"
              :maxNum="maxNum"
              :minNum="minNum"
            ></CsRuler>
          </div>
        </div>
      </div>
      <div class="q-next" v-if="data[index].value !== ''" @click="bindNext"
        >下一步</div
      >
    </div>
  </div>
</template>
<script>
import QBtn from './q-btn.vue'
import AppBar from '../app-bar.vue'
import CsRuler from '../my-ruler-row.vue'
export default {
  components: {
    QBtn,
    CsRuler,
    AppBar
  },
  props: {
    index: {
      type: Number,
      default: 0
    },
    data: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      fade: false,
      rulerNum: 55, // 刻度尺当前值
      defaultNum: 55, //刻度尺默认值
      minNum: 25,
      maxNum: 200
    }
  },
  created() {
    this.$buryPoint('BG_XRWJ_WT4', {})
    if (this.data[this.index].value) {
      this.rulerNum = this.data[this.index].value
      this.defaultNum = this.data[this.index].value
    }
  },
  methods: {
    bindRulerNum(val) {
      this.rulerNum = val
      this.data[this.index].value = val
    },
    bindNext() {
      if (this.disabled) {
        return
      }
      this.disabled = true
      this.fade = true
      setTimeout(() => {
        this.$emit('next')
      }, 500)
    }
  }
}
</script>
<style lang="scss" scoped>
.q4 {
  opacity: 1;
  transition: opacity 0.5s linear;
  position: relative;
  overflow-y: scroll;
  width: 100%;
  min-height: 100vh;
  background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q1-bg');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  .content {
    overflow: hidden;
  }
  .q-index {
    width: 328px;
    margin: 7px auto 13px;
    height: 61px;
  }
  .q-title {
    text-align: center;
    font-size: 24px;
    font-family: MaoKenTangYuan-beta, MaoKenTangYuan;
    font-weight: 600;
    color: #000000;
    line-height: 34px;
    margin-bottom: 92px;
  }
  .q-box {
    height: 350px;
    .weight-content {
      text-align: center;
      .weight-jin {
        margin-bottom: 16px;
        height: 22px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: rgba(0, 0, 0, 0.8);
        line-height: 22px;
      }
      .weight-kg {
        width: 229px;
        height: 106px;
        margin: 0 auto;
        background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q4-weight');
        background-repeat: no-repeat;
        background-size: contain;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 37px;
        .number {
          font-size: 42px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: rgba(0, 0, 0, 0.8);
          line-height: 59px;
          margin-right: 4px;
        }
        .unit {
          font-size: 15px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.9);
          line-height: 21px;
        }
      }
      .my-rule {
        margin: 0 auto 140px;
        width: 320px;
      }
    }
  }
  .q-next {
    margin: 0 auto 57px;
    text-align: center;
    line-height: 40px;
    font-weight: 600;
    width: 274px;
    height: 42px;
    box-sizing: border-box;
    border-radius: 22px;
    border: 2px solid rgba(0, 0, 0, 0.9);
  }
}
.fade {
  opacity: 0;
}
@keyframes myrotate {
  0% {
    transform: translateY(100px);
  }
  100% {
    transform: translateY(0px);
  }
}
</style>
